import React, { useState, useEffect } from 'react'
import { getHeadquarterQuarterData, getHeadquarterQuartersChart } from '../../utils/constCodeUtils';
import { useDispatch, useSelector } from 'react-redux';
import { treeDeparts } from '../../modules/deptModule/departs';
import _ from 'lodash';
import HeadquartersQuarterGoalTable from '../../components/salesgoalmng/HeadquartersQuarterGoalTable';
import HeadquartersQuarterGoalChart from '../../components/salesgoalmng/HeadquartersQuarterGoalChart';

const HeadquartersQuarterGoalContainer = () => {
  const dispatch = useDispatch();
  const [rows, setRows] = useState([])
  const [selectedRow, setSelectedRow] = useState(null);
  const [chartData, setChartData] = useState(null);

  const { departs, error, loading } = useSelector(
    ({ departModule, loading }) => ({
      departs: departModule.departs.departs,
      error: departModule.departs.error,
      loading: loading['depart/TREE_DEPART'],
    }),
  );

  useEffect(() => {
    if (!departs) {
      dispatch(treeDeparts());
    }

  }, [departs, dispatch]);

  useEffect(() => {
    if (departs?.children) {
      const filteredDeaprt = _.filter(departs?.children, (depart) => depart.Level === "1");
      const data = getHeadquarterQuarterData(filteredDeaprt);
      //console.log(data);
      setRows(data);
    }

  }, [departs])

  const handleSelectedRow = (row)=>{
   // console.log(row);
    setSelectedRow(row);
    const data = getHeadquarterQuartersChart(row);
    //console.log(chartData);
    setChartData(data)
  }

  return (
    <div>
        <HeadquartersQuarterGoalTable rows={rows} handleSelectedRow={handleSelectedRow} selectedRow={selectedRow}/>
        <HeadquartersQuarterGoalChart selectedRow={selectedRow} data={chartData}/>
    </div>
  )
}

export default HeadquartersQuarterGoalContainer